import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _PayrollLiquidateType } from "../../../core/services/dataBean/EntityCatalogVdos";
import { PayrollLiquidateTypeSelectByConst } from "./PayrollLiquidateTypeSelectByConst";



export const PayrollLiquidateType = () => {

    const PayrollLiquidateType = useDataBean(_PayrollLiquidateType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        PayrollLiquidateType.instance.getPayrollLiquidateTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        PayrollLiquidateType.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        PayrollLiquidateType.deleteItemVoid(PayrollLiquidateType.bean.IDPayrollLiquidateType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PayrollLiquidateType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPayrollLiquidateType', visible: true },

        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Liquidación', property: 'TypeName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PayrollLiquidateType.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Procesos de Liquidación de Nómina">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PayrollLiquidateType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={PayrollLiquidateType.bean.Name} onChange={PayrollLiquidateType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <PayrollLiquidateTypeSelectByConst label='Tipo de Liquidación' idSelector={PayrollLiquidateType.bean.Type} onChange={(e) => { PayrollLiquidateType.setBean({ ...PayrollLiquidateType.bean, "Type": e }) }} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={PayrollLiquidateType.bean.Description} onChange={PayrollLiquidateType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PayrollLiquidateType.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}